// extracted by mini-css-extract-plugin
module.exports = {"overlay":"UnableToUpgradeDialog_overlay__U0Hms"};